import React, { FC, useState } from 'react';

import { TabPanel } from 'devextreme-react';

import MaterialPrice from '../MaterialPrice';
import { TonarRateConfiguration } from '../TonarRateConfiguration';

const tabs = [
  {
    name: 'История цен',
    index: 0,
  },
  {
    name: 'Коэффициент тонаристам',
    index: 1,
  },
];

const itemTitleRender = (tab: { name: string; index: number }) => {
  return <span>{tab.name}</span>;
};

type Props = {
  materialId: number;
};

export const MaterialInfo: FC<Props> = ({ materialId }) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  return (
    <>
      <TabPanel
        height="auto"
        dataSource={tabs}
        selectedIndex={selectedIndex}
        onOptionChanged={(e) => {
          if (e.name === 'selectedIndex') {
            setSelectedIndex(e.value);
          }
        }}
        itemTitleRender={itemTitleRender}
        animationEnabled={false}
      />
      {selectedIndex === 0 && (
        <div>
          <MaterialPrice materialId={materialId} />
        </div>
      )}
      {selectedIndex === 1 && (
        <div>
          <TonarRateConfiguration materialId={materialId} />
        </div>
      )}
    </>
  );
};
